/**
 * Created by Miguel on 23/05/2017
 */
import { Component,Input, OnInit, ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../services/app-data.service';
import { CompanyService }  from '../../services/company.service';

//teleview
declare var $ : any;
declare var JitsiMeetExternalAPI;
declare var Swal

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'jitsi-component',
    templateUrl:'jitsi.component.html',
})
export class JitsiComponent implements OnInit {

  public api;
  public videoCall='';
  public isMobile;
  public bigStream=false;
  public conference=true;

  public shouldSave=false;

  @Input() mobile: boolean;

  constructor( public _sanitizer: DomSanitizer, public _appData : AppDataService, public _companyService: CompanyService) {
  }
  public ngOnDestroy() {

  }
  
  // within a window load,dom ready or something like that place your:
  public ngOnInit() : any {
    

  }


  public cameraMobile(){
    this.videoCall=null;
    this.mobile=true;
      if (!this._appData.instagramUser){
        $('#registerSocialModal').modal("show")
        return;
      }
      this.conference=!this.conference;
      if (this.conference){
        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // Not adding `{ audio: true }` since we only want video now
          navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream) {
  
          });
        }  
        setTimeout(()=>{
          this.startVideo('',false);
        }, 500);
        
      }
      else{
        if (this.api){  
          this.api.dispose();
          this.videoCall=""
        }
      }
}


public startVideo(roomlink,notify): boolean{

  let privateTalk=false;
            if (this.api){  
              this.api.dispose();
              this.videoCall="";
            }
            let whoamI="Privado";
            whoamI=this._appData.instagramUser.full_name;
            if (!roomlink){//abrindo por conta propria
                  //estou numa videoconferencia da pista
                    this.videoCall='vipl'+this._appData.room.id+'_'+'PISTA';
                    privateTalk=false;
                //}
            }
            else{
              this.videoCall=roomlink //aceitando convite de alguém
            }
            let querySelector=null;

            querySelector=document.querySelector('#meet')
            let tools=[];

            let domain = 'meet.jit.si';
/*            if (this._appData.room.jitsiServer){
              domain = this._appData.room.jitsiServer;
            }*/
            let user=this._appData.instagramUser;
            if (!user) {
              let date=new Date();
              let time=date.getTime();
              user={full_name:'Usuário anônimo '+time}
            }
            const options = {
                roomName: this.videoCall,
                width: '100%',
                height: '100%',
                configOverwrite: { 
                  disableDeepLinking: true, 
                  prejoinPageEnabled: false,
                  startWithAudioMuted:false,
                  startWithVideoMuted:false
                 },
                interfaceConfigOverwrite:{ 
                  SHOW_JITSI_WATERMARK: false,
                  JITSI_WATERMARK_LINK: 'https://liveparty.com.br',
                  SHOW_WATERMARK_FOR_GUESTS: false,
                  SHOW_BRAND_WATERMARK: false,
                  APP_NAME: 'LIVEPARTY',
                  TOOLBAR_BUTTONS: tools,            
                SETTINGS_SECTIONS: [ 'devices', 'language', 'moderator', 'profile'],
                MOBILE_DOWNLOAD_LINK_ANDROID: 'https://play.google.com/store/apps/details?id=com.coolkids',
                ANDROID_APP_PACKAGE: 'com.viplistas',
                NATIVE_APP_NAME: 'liveparty',
                enableCalendarIntegration: false,
                BRAND_WATERMARK_LINK: 'https://liveparty.com.br',
                DEFAULT_REMOTE_DISPLAY_NAME: whoamI,
                DEFAULT_LOCAL_DISPLAY_NAME: 'Eu',
              },
              userInfo: {
                displayName: user.full_name+'@'+user.uid
              },
              parentNode: querySelector


            };
            //        interfaceConfigOverwrite:{ MOBILE_APP_PROMO: false},

              options.interfaceConfigOverwrite.TOOLBAR_BUTTONS=[
                'fullscreen','camera','videobackgroundblur','desktop','microphone'
              ]
              options.configOverwrite.startWithVideoMuted= false

            this.api = new JitsiMeetExternalAPI(domain, options);
            this.api.executeCommand('setVideoQuality', 180);
            if (!this._appData.userLookup) this._appData.userLookup={};

            this.api.addEventListener("participantJoined",  (evt) =>{
              //evt = {
              //    id: "string", // the id of the participant
              //    displayName: "string" // the display name of the participant
              //};
              var user = {id:evt.id,name: evt.displayName};
              this._appData.userLookup[evt.id] = user;
              let min="";
              for (let us in this._appData.userLookup){
                let id=this._appData.userLookup[us].id;
                if (id>min){
                  min=id;
                }                
              }
              if (min==this._appData.instagramUser.jid){
                this.shouldSave=true;
              }
              if (this.shouldSave){
                this._companyService.updateConferenceUsers(this._appData.room).set(this._appData.userLookup);
              }

            });
            this.api.addEventListener("participantLeft",  (evt) =>{
              //evt = {
              //    id: "string", // the id of the participant
              //    displayName: "string" // the display name of the participant
              //};
              delete this._appData.userLookup[evt.id];
              let min="";
              for (let us in this._appData.userLookup){
                let id=this._appData.userLookup[us].id;
                if (id>min){
                  min=id;
                }                
              }
              if (min==this._appData.instagramUser.jid){
                this.shouldSave=true;
              }
              if (this.shouldSave){
                this._companyService.updateConferenceUsers(this._appData.room).set(this._appData.userLookup);
              }

            });

            this.api.addEventListener("videoConferenceJoined",  (evt) =>{
              var user = {id:evt.id,name: evt.displayName,uid: this._appData.instagramUser.uid};
              this._appData.userLookup[evt.id] = user;
              this._appData.instagramUser.jid=evt.id;
            });
            this.api.addEventListener("browserSupport", (evt)=>{
              let supported=evt.supported
              if (!supported){
                let dt=new Date();
                let milis=dt.getTime()
                let message="Browser não suporta nossa videoconferência. Sugerimos sempre utilizar o CHROME para o liveplanet sendo este o browser mais testado."
                let msgObj={
                  _id: milis,
                  createdAt: milis,
                  text:message,
                  event:this._appData.event.id.toString(),
                  channel:this._appData.room.id,
                  user:{
                    _id: this._appData.instagramUser.uid,
                    avatar: this._appData.instagramUser.profile_picture,
                    name: this._appData.instagramUser.full_name,
                    token:''
                  }
            }
            this._companyService.messageWriteToLocalPosition(this._appData.room.id,msgObj)
                Swal.fire({title:'Browser sem suporte',text:message});
  
              }
            })
            this.api.addEventListener("micError", (evt)=>{
              let type=evt.type
              let messagetxt=evt.message
              let message='Detectamos erro no seu microfone. Favor informar no chat a seguinte mensagem de erro:'+type +' '+messagetxt
              let dt=new Date();
              let milis=dt.getTime()
              let msgObj={
                _id: milis,
                createdAt: milis,
                text:message,
                event:this._appData.event.id.toString(),
                channel:this._appData.room.id,
                user:{
                  _id: this._appData.instagramUser.uid,
                  avatar: this._appData.instagramUser.profile_picture,
                  name: this._appData.instagramUser.full_name,
                  token:''
                }
          }
          this._companyService.messageWriteToLocalPosition(this._appData.room.id,msgObj)
              Swal.fire({title:'Microfone com erro',text:'Detectamos erro no seu microfone. Favor informar no chat a seguinte mensagem de erro:'+type +' '+messagetxt});
            })
  return true;

}
public fix(){
  let iframe=this.api.getIFrame();
  let obj={hax:"jitsi",command:"openSettings",user:''}
  iframe.contentWindow.postMessage(JSON.stringify(obj), "https://" + "viplistas.com.br/");		
}
  public removeUser(){
    let user=this._appData.userLookup["Thiago"]
    var id = "#participant_" + user.id + " audio",
    iframe = this.api.getIFrame();
    let audio = iframe.contentWindow.document.querySelector(id);
    if(audio){
//      audio.volume = volume;
    }
    else{
      console.warn("Could not find audio element for user " + user);
    }
  }
  public reload(){
    let isMobile = false;
    if (window.innerWidth<window.innerHeight){
      isMobile=true;
    }
    this.mobile=this.checkMobile();
      if (this._appData.room){
        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // Not adding `{ audio: true }` since we only want video now
          navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream) {
          });
        }  
        setTimeout(()=>{
          this.startVideo(null,false);
        }, 500);     
      }
      else{
        if (this.api){  
          this.api.dispose();
          this.videoCall="";
        }
  
    }
  }

  public checkMobile(){
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    return check;
  }


}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/jitsi-component/jitsi.component.ts